class deliverySchedules extends HTMLElement {
  constructor() {
    super();
    if (!window?.deliveryScheduleInfo) return;
    const _this = this;
    this.currentDate = new Date();
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 60);
    this.ignoreYear = true;
    this.currentCartItem = null;
    this.globalExclusions = JSON.parse(this.dataset.globalExclusions || "[]");

    const wrapper = this.closest(".delivery-schedules-wrapper");
    this.mode =
      wrapper && wrapper.querySelector("input[data-mode]")
        ? wrapper.querySelector("input[data-mode]").dataset.mode
        : "delivery";
    this.datepickerId = `datepicker-${this.mode}`;

    this.bindEvents();
    localStorage.removeItem("delivery_schedule");
    this.pikaDayFnc(this);
    this.initializeEmptyState();

    if (window.pageType === "cart") {
      this.earliestDeliveryMessage();
    }

    //show earliest delivery schedule message
    if (
      window.pageType === "cart" &&
      this.querySelector(".earliest-delivery-schedule")
    ) {
      const earliestDeliverySchedule = this.findEarliestDeliverySchedule();
      this.querySelector(".earliest-delivery-schedule").innerHTML = `${
        this.querySelector(".earliest-delivery-schedule").dataset.icon
      } ${
        this.querySelector(".earliest-delivery-schedule").dataset
          .earliestDeliverySchedule
      } ${earliestDeliverySchedule}`;
    }

    //check when product cards loaded
    document.addEventListener("filter:sections_loaded", () => {
      _this.checking_product_card();
      // this.earliestDeliveryMessage();
    });

    //show cart alert when cart gets modified
    document.addEventListener("cart:modified", () => {
      this.showCartAlert();
      this.earliestDeliveryMessage();
      this.setInitials();
    });

    //restrict checkout form submission when schedule don't match
    document.querySelector('button[name="checkout"]') &&
      document
        .querySelector('button[name="checkout"]')
        .addEventListener("click", (e) => {
          this.currentDate = new Date();
        });

    if (window.pageType === "cart") {
      //set cart refresh interval
      let cartRefreshCounter = 0;
      const cartRefreshInterval = setInterval(() => {
        cartRefreshCounter++;
        if (cartRefreshCounter >= 300) {
          clearInterval(cartRefreshInterval);
          location.reload();
        }
      }, 1000);
    }

    //check tab change to get the cart state
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && window.pageType === "cart") {
        this.currentDate = new Date();
      }
    });

    window.onfocus = () => {
      if (window.pageType === "cart") {
        this.currentDate = new Date();
      }
    };
  }

  getDeliveryMessage = (scheduleDates) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    return scheduleDates.map((scheduleDate) => {
      const datePart =
        scheduleDate.customDateFormat.split(" ")[0] +
        " " +
        scheduleDate.customDateFormat.split(" ")[1];
      const fullDate = new Date(`${datePart} ${new Date().getFullYear()}`);
      fullDate.setHours(0, 0, 0, 0);

      if (fullDate.getTime() === today.getTime()) {
        return "Today";
      } else if (fullDate.getTime() === tomorrow.getTime()) {
        return "Tomorrow";
      } else {
        // Format date as "15 Dec 2024"
        const day = fullDate.getDate();
        const month = fullDate.toLocaleString("en-US", { month: "short" });
        const year = fullDate.getFullYear();
        return `${day} ${month} ${year}`;
      }
    });
  };

  dateToMilliseconds(date) {
    if (!date?.getMonth || typeof date.getMonth !== "function") {
      date = new Date(date);
    }
    if (!date?.getTime) return null;

    return date.getTime();
  }

  isWithinCutoffTime(timeslot, selectedDate) {
    if (!selectedDate) return null;
    const cutoffDatetimeString = timeslot?.cutoff_time
      ? this.ignoreYear
        ? `${selectedDate}T${timeslot.cutoff_time.split("T")[1]}`
        : timeslot.cutoff_time
      : selectedDate;
    const processDays = timeslot?.process_days || 0;
    let cutoffDate = new Date(cutoffDatetimeString);
    cutoffDate.setDate(cutoffDate.getDate() - processDays);

    return (
      this.dateToMilliseconds(this.currentDate) <
      this.dateToMilliseconds(cutoffDate)
    );
  }

  isTimeSlotAvailable(storedTimeSlot, selectedDate) {
    if (!storedTimeSlot || !selectedDate) return false;

    const schedule = {
      date: selectedDate,
      day: this.nameOfDay(selectedDate),
      time_slot: "",
      timeslot_raw: null,
    };

    const result = this.findAvailability(window.deliveryScheduleInfo, schedule);
    if (!result?.availableTimeslots?.length) return false;

    return result.availableTimeslots.some((timeslot) => {
      return storedTimeSlot === timeslot.timeslot_label;
    });
  }

  findEarliestDeliverySchedule(returntHtml = true) {
    const deliveryScheduleData = window.deliveryScheduleInfo;
    let checkDate = this.getEarliestConstraintDate();
    let deliverySchedule = {},
      count = 0;
    checkDate =
      this.ignoreYear &&
      new Date(checkDate.setFullYear(this.currentDate.getFullYear()));
    do {
      const dateValue = this.dateFormat(checkDate);
      const day = this.nameOfDay(checkDate);
      const currentSchedule = {
        day: day,
        date: dateValue,
        time_slot: "",
        timeslot_raw: null,
      };
      const result = this.findAvailability(
        deliveryScheduleData,
        currentSchedule
      );
      let timeslots =
        result?.isProductAvailable &&
        !!result?.availableTimeslots?.length &&
        result.availableTimeslots.filter(
          (slot) => this.isWithinCutoffTime(slot, dateValue) && slot
        );
      timeslots =
        !!timeslots?.length &&
        timeslots.sort((a, b) => {
          const aTimeParts = a.time_from.split("T")[1].split("Z")[0].split(":");
          const bTimeParts = b.time_from.split("T")[1].split("Z")[0].split(":");
          return (
            parseInt(aTimeParts[0]) * 60 +
            parseInt(aTimeParts[1]) -
            (parseInt(bTimeParts[0]) * 60 + parseInt(bTimeParts[1]))
          );
        });
      if (!!timeslots?.length) {
        deliverySchedule = {
          date: currentSchedule.date,
          day: currentSchedule.day,
          timeslot: timeslots[0],
        };
      } else {
        checkDate.setDate(checkDate.getDate() + 1);
      }
      count++;
    } while (!deliverySchedule?.timeslot && count < 180);
    this.currentDate = new Date();
    if (returntHtml) {
      const deliveryDate = new Date(deliverySchedule.date);
      const inDateMonth = deliveryDate.toLocaleDateString("en-SG", {
        day: "numeric",
        month: "short",
      });
      return `${inDateMonth} ${deliverySchedule.timeslot.timeslot_label.replace(
        " - ",
        "-"
      )}`;
    } else {
      return deliverySchedule;
    }
  }

  getEarliestConstraintDate() {
    const items = Array.from(
      document.querySelectorAll("#main-cart-items .cart-item")
    );
    const dates = items
      .map((el) => new Date(el.dataset.earliestDelivery))
      .filter((d) => !isNaN(d));

    if (dates.length === items.length) {
      return new Date(Math.min(...dates));
    }

    return this.currentDate;
  }

  findAvailability(scheduleData, currentDeliverySchedule) {
    if (
      typeof scheduleData !== "object" ||
      typeof currentDeliverySchedule != "object" ||
      !currentDeliverySchedule?.date
    )
      return null;

    let isProductAvailable = false,
      availableTimeslots = [];
    const date = new Date(currentDeliverySchedule.date);
    const {
      timeslots,
      timeSlotOverride,
      dateExclusions,
      earliestDeliveryDate,
    } = scheduleData;

    const globalExclusions = this.globalExclusions || [];
    const timeOverrideGlobal =
      window.deliveryScheduleInfo.timeSlotOverrideGlobal;
    const cartItems = [
      ...document.querySelectorAll("#main-cart-items .cart-item"),
    ];
    let excludedDates = [];
    let mergedOverrides = [];

    // const anyMissingExclusions = cartItems.some((el) => {
    //   const itemExclusions = JSON.parse(el.dataset.dateExclusions || "[]");
    //   return itemExclusions.length === 0;
    // });

    // if (anyMissingExclusions) {
    //   excludedDates = globalExclusions;
    // } else {
    excludedDates = [
      ...new Set(
        cartItems.flatMap((el) => JSON.parse(el.dataset.dateExclusions || "[]"))
      ),
    ];
    // }
    const anyMissingOverrides = cartItems.some((el) => {
      const val = el.dataset.timeOverride;
      let parsed = JSON.parse(val);
      return !parsed || (Array.isArray(parsed) && parsed.length === 0);
    });

    mergedOverrides = anyMissingOverrides
      ? timeOverrideGlobal
      : cartItems.flatMap((el) => JSON.parse(el.dataset.timeOverride));

    //compare against earliest delivery date
    let edDate = null;
    if (window.pageType === "cart") {
      edDate = this.getEarliestConstraintDate();
    } else {
      edDate = earliestDeliveryDate ? new Date(earliestDeliveryDate) : null;
    }

    const earliestDeliveryDateValue =
      this.ignoreYear && edDate
        ? this.dateFormat(
            new Date(edDate.setFullYear(this.currentDate.getFullYear()))
          )
        : earliestDeliveryDate;
    isProductAvailable =
      earliestDeliveryDateValue &&
      this.dateToMilliseconds(earliestDeliveryDateValue) &&
      this.dateToMilliseconds(earliestDeliveryDateValue) >
        this.dateToMilliseconds(date)
        ? false
        : true;

    const fullDateFormat = this.dateFormat(date);

    if (window.pageType === "cart") {
      if (cartItems.length === 1) {
        const singleItemExclusions = JSON.parse(
          cartItems[0]?.dataset?.dateExclusions || "[]"
        );
        if (singleItemExclusions.includes(fullDateFormat)) {
        isProductAvailable = false;
      }
    }
    }
    // if (!!excludedDates?.length) {
    //   if (excludedDates.includes(fullDateFormat)) {
    //     isProductAvailable = false;
    //   }
    // }

    //compare against timeslot override
    const findOverrideEntryMatch =
      !!mergedOverrides?.length &&
      mergedOverrides.filter(
        (entry) =>
          this.dateFormat(entry.time_to) === this.dateFormat(date) ||
          this.dateFormat(entry.time_from) === this.dateFormat(date)
      );

    if (isProductAvailable) {
      if (findOverrideEntryMatch?.length) {
        availableTimeslots =
          !!findOverrideEntryMatch?.length &&
          findOverrideEntryMatch.map((slot) => {
            const overrideDay = this.nameOfDay(slot.time_from);
            return {
              id: slot.id,
              cutoff_time: slot.cutoff_time,
              day: overrideDay,
              process_days: slot.process_days,
              time_from: slot.time_from,
              time_to: slot.time_to,
              timeslot_label: slot.timeslot_label,
            };
          });
        availableTimeslots = availableTimeslots.filter(
          (slot) =>
            slot &&
            currentDeliverySchedule.day.toLowerCase() === slot.day.toLowerCase()
        );
      } else {
        availableTimeslots =
          !!timeslots?.length &&
          currentDeliverySchedule?.day &&
          timeslots.filter(
            (slot) =>
              currentDeliverySchedule.day.toLowerCase() ===
              slot.day.toLowerCase()
          );
      }
    }

    availableTimeslots =
      !!availableTimeslots?.length &&
      availableTimeslots.filter((slot) => {
        const slotDatetimeString = this.ignoreYear
          ? `${currentDeliverySchedule.date}T${slot.time_to.split("T")[1]}`
          : slot.time_to;
        return (
          slotDatetimeString &&
          this.dateToMilliseconds(slotDatetimeString) &&
          this.dateToMilliseconds(slotDatetimeString) >
            this.dateToMilliseconds(this.currentDate)
        );
      });

    isProductAvailable = !!availableTimeslots?.length;

    //if timeslot exists in current delivery schedule
    if (currentDeliverySchedule?.timeslot_raw) {
      const matchingTimeslots =
        !!availableTimeslots?.length &&
        availableTimeslots.filter(
          (slot) =>
            slot.time_from === currentDeliverySchedule.timeslot_raw.time_from &&
            slot.time_to === currentDeliverySchedule.timeslot_raw.time_to
        );
      isProductAvailable = !!matchingTimeslots?.length;
    }

    return {
      isProductAvailable: isProductAvailable,
      availableTimeslots: availableTimeslots,
    };
  }

  setInitials(date, timeString, timeslot, isTimeListClick) {
    const initialData = this.getCurrentDeliverySchedule();
    const _this = this;
    if (date && typeof date.getTime === "function") {
      initialData.date = this.dateFormat(date);
      initialData.day = this.nameOfDay(initialData.date);

      if (timeString && typeof timeslot === "object") {
        initialData.time_slot = timeString;
        initialData.timeslot_raw = timeslot;
      } else {
        if (
          !initialData?.timeslot_raw ||
          initialData.day !== initialData.timeslot_raw.day
        ) {
          initialData.time_slot = "";
          initialData.timeslot_raw = null;
        }
      }
    }

    !this.currentCartItem &&
      localStorage.setItem("delivery_schedule", JSON.stringify(initialData));
    window.delivery_schedule = initialData;
    const currentDate = initialData.date;
    const datepickerInput = document.getElementById(this.datepickerId);
    if (datepickerInput && currentDate) {
    const currentDateParts = currentDate.split("-");
      datepickerInput.value = `${currentDateParts[2]}/${currentDateParts[1]}/${currentDateParts[0]}`;
      datepickerInput.setAttribute(
        "value",
        `${currentDateParts[2]}/${currentDateParts[1]}/${currentDateParts[0]}`
      );
    } else if (datepickerInput && !currentDate) {
      datepickerInput.value = "Select Date";
      datepickerInput.removeAttribute("value");
    }
    this.querySelector(".selected_time .h4").innerHTML =
      initialData.time_slot !== "" ? initialData.time_slot : "Select Time";

    if (document.querySelector("#delivery_date_property")) {
      if (timeString)
        document.querySelector(
          "#delivery_date_property"
        ).value = `${currentDate}, ${timeString.trim()}`;
      else if (initialData?.time_slot)
        document.querySelector(
          "#delivery_date_property"
        ).value = `${currentDate}, ${initialData.time_slot.trim()}`;
      else document.querySelector("#delivery_date_property").value = "";
    }
    const timelsotIdNode = document.querySelector("#delivery_time_slot_id");
    if (timelsotIdNode) {
      timelsotIdNode.value = initialData?.timeslot_raw?.id
        ? initialData?.timeslot_raw?.id
        : "";
    }
      this.time_listShowHide(initialData);
    this.checking_product_card();
    if (
      this.querySelector(".selected_time .h4").getAttribute("template") !=
      "collection"
    ) {
      this.checking_addToCartButton();
    }

    this.showCartAlert();

    if (initialData.date && initialData.time_slot) {
      const checkoutBtn = document.querySelector('[name="checkout"]');
      const dateInput = document.getElementById("checkout_date");
      const timeInput = document.getElementById("checkout_time");
      const typeInput = document.querySelector(
        "input[name='attributes[Type]']"
      );
      const type = typeInput && typeInput.value ? typeInput.value : "delivery";

      // if (checkoutBtn) {
      //   checkoutBtn.removeAttribute("disabled");
      //   checkoutBtn.classList.remove("disabled");
      //   checkoutBtn.setAttribute("type", "submit");
      // }

      if (dateInput) {
        dateInput.value = initialData.date;
        dateInput.setAttribute(
          "name",
          type === "delivery" ? "attributes[date]" : "attributes[Pickup-Date]"
        );
      }

      if (timeInput) {
        timeInput.value = initialData.time_slot;
        timeInput.setAttribute(
          "name",
          type === "delivery"
            ? "attributes[timeslot]"
            : "attributes[Pickup-Time]"
        );
      }
    }

    if (this.currentCartItem && isTimeListClick) {
      setTimeout(() => {
        let properties = {
          ...this.currentCartItem.item.properties,
          Delivery: `${currentDate}, ${initialData.time_slot.trim()}`,
          _timeslot_id: initialData?.timeslot_raw?.id
            ? `${initialData.timeslot_raw.id}`
            : "",
        };
        if (window.surchargeInfo) {
          if (
            !(
              window.surchargeInfo.startDateInMilliseconds <=
                this.dateToMilliseconds(currentDate) &&
              window.surchargeInfo.endDateInMilliseconds >=
                this.dateToMilliseconds(currentDate)
            )
          ) {
            delete properties["Price with surcharge"];
          } else {
            if (
              window.surchargeInfo.currentPrices[
                this.currentCartItem.item.id.split(":")[0]
              ]
            ) {
              properties["Price with surcharge"] =
                window.surchargeInfo.currentPrices[
                  this.currentCartItem.item.id.split(":")[0]
                ];
            }
          }
        }

        if (customShippingRate) {
          properties["_custom_shipping"] = customShippingRate;
        } else {
          delete properties["_custom_shipping"];
        }

        const body = JSON.stringify({
          id: this.currentCartItem.item.id,
          properties: properties,
        });
        const line = this.currentCartItem.item.line;

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            document
              .querySelector(".delivery-schedule-modal")
              .classList.add("hide");
            _this.currentCartItem = null;
            document.body.classList.remove("modal-opened");
            location.reload();

            const cartItems =
              _this.closest("cart-items") || _this.closest("cart-drawer-items");

            const items = cartItems.querySelectorAll(".cart-item");

            if (parsedState.errors) {
              cartItems.updateLiveRegions(line, parsedState.errors);
              return;
            }

            cartItems.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );
            const cartDrawerWrapper = document.querySelector("cart-drawer");
            const cartFooter = document.getElementById("main-cart-footer");

            if (cartFooter)
              cartFooter.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );
            if (cartDrawerWrapper)
              cartDrawerWrapper.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );

            cartItems.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });

            this.updateLiveRegions(line, message);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "cart-items",
              cartData: parsedState,
              variantId: variantId,
            });
            //dispatch custom event
            const customEvent = new CustomEvent("cart:modified");
            document.dispatchEvent(customEvent);
          })
          .catch(() => {
            const errors =
              document.getElementById("cart-errors") ||
              document.getElementById("CartDrawer-CartErrors");
            errors.textContent = window.cartStrings.error;
          })
          .finally(() => {});
      }, 100);
    }
  }

  initializeEmptyState() {
    const datepickerInput = document.getElementById(this.datepickerId);
    const selectedTimeHeader = this.querySelector(".selected_time .h4");
    if (datepickerInput) datepickerInput.value = "Select Date";
    if (selectedTimeHeader) selectedTimeHeader.textContent = "Select Time";

    window.delivery_schedule = {
      date: "",
      day: "",
      time_slot: "",
      timeslot_raw: null,
    };
  }

  getCurrentDeliverySchedule() {
    const today = this.dateFormat(this.currentDate);
    const earliestDeliverySchedule = this.findEarliestDeliverySchedule(false);
    const storedSchedule = JSON.parse(
      localStorage.getItem("delivery_schedule")
    );

    let result;
    if (
      storedSchedule &&
      earliestDeliverySchedule?.date &&
      this.dateToMilliseconds(earliestDeliverySchedule.date) <=
        this.dateToMilliseconds(storedSchedule.date)
    ) {
      if (
        !this.isTimeSlotAvailable(storedSchedule.time_slot, storedSchedule.date)
      ) {
        result = {
          date: storedSchedule.date,
          day: storedSchedule.day,
          time_slot: "",
          timeslot_raw: null,
        };
      } else {
        result = storedSchedule;
      }
    } else {
      result = {
        date: "",
        day: "",
        time_slot: "",
        timeslot_raw: null,
        };
    }

    return result;
  }

  bindEvents() {
    this.querySelectorAll(".time-wrap").forEach((item) => {
      item.addEventListener("click", this.onSummaryClick.bind(this));
    });
    this.querySelectorAll(".time-list li").forEach((time_list) => {
      time_list.addEventListener("click", this.onTimeListClick.bind(this));
    });
  }

  // onSummaryClick(event) {
  //   this.querySelectorAll(".time-list").forEach((time_list) => {
  //     time_list.classList.toggle("active");
  //   });
  // }

  onSummaryClick(event) {
    this.querySelectorAll(".time-list").forEach((time_list) => {
      if (time_list.children.length > 0) {
      time_list.classList.toggle("active");
      }
    });
  }

  onTimeListClick(event, schedule) {
    const currentDeliverySchedule =
      schedule || this.getCurrentDeliverySchedule();
    const dateString = event.currentTarget.innerHTML;
    const timeslotData = event.currentTarget.dataset?.item
      ? JSON.parse(event.currentTarget.dataset.item)
      : null;
    this.querySelectorAll(".time-list").forEach((time_list) => {
      time_list.classList.remove("active");
    });

    this.setInitials(
      new Date(currentDeliverySchedule.date),
      dateString,
      timeslotData,
      true
    );
  }

  pikaDayFnc() {
    var $this = this;
    const currentDeliverySchedule = this.getCurrentDeliverySchedule();
    const datepickerInput = document.getElementById(this.datepickerId);
    this.picker = new Pikaday({
      field: datepickerInput,
      format: "DD-MM-YYYY",
      minDate: $this.currentDate,
      maxDate: $this.maxDate,
      // defaultDate: new Date(currentDeliverySchedule.date),
      setDefaultDate: false,
      disableWeekends: false,
      toString(date, format) {
        // you should do formatting based on the passed format,
        var get_Month = date.getMonth() + 1;
        var get_Date = date.getDate();
        const day = get_Date > 9 ? get_Date : "0" + get_Date;
        const month = get_Month > 9 ? get_Month : "0" + get_Month;
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
      disableDayFn: function (date) {
        return $this.isDatedisable(date); // if show without array date
      },
      onSelect() {
        const date = this._d;
        $this.setInitials(date);
        $this.showCartAlert();
      },
    });
  }

  dateFormat(date, mode) {
    if (typeof date.getMonth !== "function") date = new Date(date);
    if (typeof date.getTime !== "function") return "";
    const get_Date = date.getDate();
    const get_Month = date.getMonth() + 1;
    const day = get_Date > 9 ? get_Date : "0" + get_Date;
    const month = get_Month > 9 ? get_Month : "0" + get_Month;
    // const year = this.ignoreYear ? this.currentDate.getFullYear() : date.getFullYear();
    const year = this.ignoreYear && date.getFullYear();
    const hours = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
    const minutes =
      date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
    const seconds =
      date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();

    if (mode === "md") {
      return month + "-" + day;
    }

    if (mode === "hms") {
      return hours + ":" + minutes + ":" + seconds;
    }

    return year + "-" + month + "-" + day;
  }

  isDatedisable(date) {
    const formattedDate = this.dateFormat(date);
    const earliestDeliverySchedule = this.findEarliestDeliverySchedule(false);
    const schedule = {
      date: formattedDate,
      day: this.nameOfDay(date),
      time_slot: "",
      timeslot_raw: null,
    };
    const result = this.findAvailability(window.deliveryScheduleInfo, schedule);

    return (
      Datedisable.includes(formattedDate) ||
      this.dateToMilliseconds(earliestDeliverySchedule.date) >
        this.dateToMilliseconds(formattedDate) ||
      !result?.availableTimeslots?.length
    );
  }

  nameOfDay(dateValue) {
    if (!dateValue) return null;
    var date =
      dateValue?.getTime && typeof dateValue.getTime === "function"
        ? dateValue
        : new Date(dateValue); // Example date: March 20, 2024
    var dayIndex = date.getDay();
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var dayName = days[dayIndex];
    return dayName;
  }

  setLocalTime(
    date = this.currentDate,
    time = { h: 0, m: 0, s: 0, ms: 0 },
    tz = "Asia/Singapore"
  ) {
    let { h, m, s, ms } = time;
    let z = (n, len) => ("00" + n).slice(-len);

    let [datePart, offset] = date
      .toLocaleDateString("sv", {
        timeZone: tz,
        timeZoneName: "longOffset",
      })
      .split(" GMT");

    let timestamp =
      `${datePart}T` +
      `${z(h || 0, 2)}:${z(m || 0, 2)}:${z(s || 0, 2)}.${z(ms || 0, 3)}` +
      `${offset.replace(String.fromCharCode(8722), "-")}`;

    return new Date(timestamp);
  }

  time_listShowHide(schedule) {
    const currentDeliverySchedule =
      schedule || this.getCurrentDeliverySchedule();
    const deliveryScheduleInfo =
      this.currentCartItem?.deliverySchedule || window.deliveryScheduleInfo;
    const result = this.findAvailability(
      deliveryScheduleInfo,
      currentDeliverySchedule
    );
    this.querySelector(".time-list").innerHTML = "";
    !!result?.availableTimeslots?.length
      ? result?.availableTimeslots.forEach((timeSlot) => {
          const slotEl = document.createElement("li");
          slotEl.dataset.item = JSON.stringify(timeSlot);
          slotEl.dataset.time_from = timeSlot.time_from;
          slotEl.dataset.time_to = timeSlot.time_to;
          slotEl.dataset.day = timeSlot.day;
          slotEl.innerHTML = timeSlot.timeslot_label;
          slotEl.addEventListener("click", (e) => {
            this.onTimeListClick(e, schedule);
          });
          !this.isWithinCutoffTime(timeSlot, currentDeliverySchedule.date)
            ? slotEl.classList.add("disabled")
            : slotEl.classList.remove("disabled");
          this.querySelector(".time-list").appendChild(slotEl);
        })
      : (this.querySelector(
          ".time-list"
        ).innerHTML = `<li class="no-slots-available">${
          window.deliveryScheduleInfo.noSlotsAvailableText ||
          "No slots available"
        }</li>`);

    if (
      this.querySelector(".time-list li:not(.disabled)") &&
      !currentDeliverySchedule?.timeslot_raw &&
      window.pageType === "cart"
    ) {
      this.querySelector(".time-list li:not(.disabled)").click();
    }
  }

  checking_product_card() {
    var productItems = document.querySelectorAll("[data-product-card]");
    !!productItems?.length &&
      productItems.forEach((el) => {
        const deliveryScheduleData = el.dataset.deliverySchedule
          ? JSON.parse(el.dataset.deliverySchedule)
          : null;
        const currentSchedule = this.getCurrentDeliverySchedule();
        const result = this.findAvailability(
          deliveryScheduleData,
          currentSchedule
        );
        if (!currentSchedule?.timeslot_raw) {
          el.querySelector(".product-availability").classList.remove(
            "available"
          );
          el.querySelector(".product-availability").innerHTML = "";
        } else {
          if (result?.isProductAvailable) {
            el.querySelector(".product-availability").classList.add(
              "available"
            );
            el.querySelector(".product-availability").innerHTML =
              el.querySelector(
                ".product-availability"
              ).dataset.contentAvailable;
          } else {
            el.querySelector(".product-availability").classList.remove(
              "available"
            );
            el.querySelector(".product-availability").innerHTML =
              el.querySelector(
                ".product-availability"
              ).dataset.contentUnavailable;
          }
        }
      });
  }

  checking_addToCartButton() {
    const currentSchedule = this.getCurrentDeliverySchedule();
    const availability = this.findAvailability(
      window.deliveryScheduleInfo,
      currentSchedule
    );
    const container = document.querySelector(".cart__footer");

    if (!container) return;

    setTimeout(() => {
      const isAvailable = availability?.isProductAvailable;
      const hasTimeSlot = currentSchedule.timeslot_raw;
      const isWithinCutoff = this.isWithinCutoffTime(
        currentSchedule.timeslot_raw,
        currentSchedule.date
      );

      // const checkoutButton = container.querySelector(".cart__checkout-button");
      // if (!checkoutButton) return;

      // checkoutButton.classList.toggle(
      //   "disabled-addtocart",
      //   !(isAvailable && hasTimeSlot && isWithinCutoff)
      // );
    }, 100);
  }

  showCartAlert() {
    if (!document.querySelector(".cart__contents")) return;

    const currentSchedule = this.getCurrentDeliverySchedule();
    const alertEl = document.querySelector(".alert-message-global");

    if (!currentSchedule.date && !currentSchedule.time_slot) {
      if (alertEl) {
        alertEl.classList.add("hide");
      }
      return;
    }

    let showGlobalAlert = false,
      disableCheckout = false;
    const cartItems = [
      ...document.querySelectorAll("#main-cart-items .cart-item"),
    ];

    let excludedDates = [];
    excludedDates = [
      ...new Set(
        cartItems.flatMap((el) => JSON.parse(el.dataset.dateExclusions || "[]"))
      ),
    ];

    const allHaveDeliverySchedule =
      cartItems.length > 0 &&
      cartItems.every((item) => item.dataset.hasDeliverySchedule === "true");
    const anyHaveDeliverySchedule = cartItems.some(
      (item) => item.dataset.hasDeliverySchedule === "true"
    );
    const earliestDates = cartItems
      .map((el) => el.dataset.earliestDelivery || "")
      .filter((v) => v !== "");
    const dateExclusionsList = cartItems.map((el) =>
      JSON.parse(el.dataset.dateExclusions || "[]").filter(
        (arr) => arr.length > 0
      )
    );

    const hasMismatchedEarliest =
      earliestDates.length > 1 && new Set(earliestDates).size > 1;
    const hasMismatchedExclusions =
      dateExclusionsList.length > 1 &&
      !dateExclusionsList.every(
        (arr) => JSON.stringify(arr) === JSON.stringify(dateExclusionsList[0])
      );

    const timeOverrideList = cartItems.map((el) => {
      return el.dataset.timeOverride ? JSON.parse(el.dataset.timeOverride) : [];
    });
    const timeStringsList = timeOverrideList.map((overrides) =>
      overrides
        ?.map((ov) => `${ov.time_from}-${ov.time_to}`)
        .sort()
        .join(",")
    );

    const hasMismatchedTimeOverrides =
      timeStringsList.length > 1 &&
      !timeStringsList.every((str) => str === timeStringsList[0]);

    if (
      allHaveDeliverySchedule &&
      !hasMismatchedEarliest &&
      !hasMismatchedExclusions &&
      !hasMismatchedTimeOverrides
    ) {
      showGlobalAlert = false;
      disableCheckout = false;
    } else if (
      anyHaveDeliverySchedule ||
      hasMismatchedEarliest ||
      hasMismatchedExclusions ||
      hasMismatchedTimeOverrides
        ) {
          showGlobalAlert = true;
          disableCheckout = true;
    }

    const unavailableEl = document.getElementById("unavailable-products");
    const unavailableNames = [];

    const selectedDate = this.getCurrentDeliverySchedule().date;
    const earliestSchedules = this.findEarliestDeliveryScheduleCart(false);
    const dates = earliestSchedules
      .map((item) => item.deliverySchedule?.date)
      .filter(Boolean);
    const maxDate = dates.length
      ? new Date(Math.max(...dates.map((d) => new Date(d))))
      : null;
    const earliestDate = maxDate;

    cartItems.forEach((el, idx) => {
      const productName = el.dataset.productName;
      const itemDate = dates[idx];
      const dateExclusions = JSON.parse(el.dataset.dateExclusions || "[]");
      const itemTimeOverrides = timeOverrideList[idx] || [];
      let matchesOverride = false;

      itemTimeOverrides.forEach((ov) => {
        if (!ov.time_from || !ov.time_to) return;

        const start = ov.time_from?.split("T")[0];
        const end = ov.time_to?.split("T")[0];

        if (selectedDate >= start && selectedDate <= end) {
          matchesOverride = true;
        }
      });

      if (itemDate && selectedDate) {
      if (
          this.dateToMilliseconds(itemDate) >
          this.dateToMilliseconds(selectedDate)
      ) {
          unavailableNames.push(productName);
      }
      }

      if (selectedDate && dateExclusions.includes(selectedDate)) {
        if (!unavailableNames.includes(productName)) {
          unavailableNames.push(productName);
    }
      }

      if (matchesOverride && !unavailableNames.includes(productName)) {
        unavailableNames.push(productName);
    }
    });

    if (unavailableEl) {
      unavailableEl.textContent = unavailableNames.length
        ? unavailableNames.join(", ")
        : "Some products";
    }

    if (excludedDates.includes(selectedDate)) {
      showGlobalAlert = true;
      disableCheckout = true;
    } else {
      const overrideDates = [];
      timeOverrideList.forEach((overrideArr) => {
        overrideArr.forEach((ov) => {
          if (ov.time_from && ov.time_to) {
            const startDate = new Date(ov.time_from);
            const endDate = new Date(ov.time_to);

            for (
              let d = new Date(startDate);
              d <= endDate;
              d.setDate(d.getDate() + 1)
            ) {
              overrideDates.push(this.dateFormat(new Date(d)));
            }
          } else if (ov.time_from) {
            overrideDates.push(this.dateFormat(ov.time_from));
          } else if (ov.time_to) {
            overrideDates.push(this.dateFormat(ov.time_to));
          }
        });
      });
      // timeOverrideList.forEach((overrideArr) => {
      //   overrideArr.forEach((ov) => {
      //     if (ov.time_from) overrideDates.push(this.dateFormat(ov.time_from));
      //     if (ov.time_to) overrideDates.push(this.dateFormat(ov.time_to));
      //   });
      // });

      if (overrideDates.includes(selectedDate) && hasMismatchedTimeOverrides) {
        showGlobalAlert = true;
        disableCheckout = true;
      } else if (
        this.dateToMilliseconds(selectedDate) >=
        this.dateToMilliseconds(earliestDate)
      ) {
        showGlobalAlert = false;
        disableCheckout = false;
        if (document.querySelector(".alert-message-global")) {
          document.querySelector(".alert-message-global").innerHTML = "";
        }
      }
    }

    if (alertEl) {
      if (!alertEl.innerHTML?.trim()) {
        alertEl.innerHTML = alertEl.dataset.html || "";
      }
      alertEl.classList.toggle("hide", !showGlobalAlert);
    }

    if (showGlobalAlert || disableCheckout) {
      const checkoutBtn = document?.querySelector('[name="checkout"]');
      checkoutBtn?.setAttribute("disabled", "disabled");
      checkoutBtn?.removeAttribute("type");
      checkoutBtn?.classList.add("disabled");
    } else {
      const checkoutBtn = document?.querySelector('[name="checkout"]');
      checkoutBtn?.removeAttribute("disabled");
      checkoutBtn?.setAttribute("type", "submit");
      checkoutBtn?.classList.remove("disabled");
    }
  }

  earliestDeliveryMessage = () => {
    if (window.pageType !== "cart") return;
    const earliestDeliverySchedule = this.findEarliestDeliveryScheduleCart();
    const deliveryMessage = this.getDeliveryMessage(earliestDeliverySchedule);
    const cartItems = document.querySelectorAll("#main-cart-items .cart-item");
    cartItems.forEach((item, index) => {
      if (deliveryMessage[index]) {
        const deliveryElement = item.querySelector(
          ".cart-earliest-delivery-schedule"
        );
        const message = deliveryMessage[index];
        const isToday = message.includes("Today");
        const truckIconSVG = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1.875H0.625V10H10V1.875Z" stroke="#6B7177" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 5H12.5L14.375 6.875V10H10V5Z" stroke="#6B7177" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.4375 13.125C4.30044 13.125 5 12.4254 5 11.5625C5 10.6996 4.30044 10 3.4375 10C2.57456 10 1.875 10.6996 1.875 11.5625C1.875 12.4254 2.57456 13.125 3.4375 13.125Z" stroke="#6B7177" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.5625 13.125C12.4254 13.125 13.125 12.4254 13.125 11.5625C13.125 10.6996 12.4254 10 11.5625 10C10.6996 10 10 10.6996 10 11.5625C10 12.4254 10.6996 13.125 11.5625 13.125Z" stroke="#6B7177" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;
        if (deliveryElement) {
          deliveryElement.innerHTML = `${truckIconSVG} <span class="customize-title">${
            deliveryElement.dataset.earliestDeliverySchedule
          }</span> <span style="${
            isToday ? "font-weight: bold; color: #335942;" : ""
          }">${deliveryMessage[index]}</span>`;
        }
      }
    });
  };

  findEarliestDeliveryScheduleCart(returntHtml = true) {
    var cartItems = document.querySelectorAll(
      "#main-cart-items .cart-item .cart-item__earliest-delivery"
    );
    const earliestDeliveryData = [];
    !!cartItems?.length &&
      cartItems.forEach((el) => {
        const deliveryScheduleData = el.dataset.deliverySchedule
          ? JSON.parse(el.dataset.deliverySchedule)
          : null;

        let checkDate = deliveryScheduleData?.earliestDeliveryDate
          ? new Date(deliveryScheduleData.earliestDeliveryDate)
          : this.currentDate;
        let deliverySchedule = {},
          count = 0;
        checkDate =
          this.ignoreYear &&
          new Date(checkDate.setFullYear(this.currentDate.getFullYear()));
        do {
          const dateValue = this.dateFormat(checkDate);
          const day = this.nameOfDay(checkDate);
          const currentSchedule = {
            day: day,
            date: dateValue,
            time_slot: "",
            timeslot_raw: null,
          };
          const result = this.findAvailability(
            deliveryScheduleData,
            currentSchedule
          );
          let timeslots =
            result?.isProductAvailable &&
            !!result?.availableTimeslots?.length &&
            result.availableTimeslots.filter(
              (slot) => this.isWithinCutoffTime(slot, dateValue) && slot
            );
          timeslots =
            !!timeslots?.length &&
            timeslots.sort((a, b) => {
              const aTimeParts = a.time_from
                .split("T")[1]
                .split("Z")[0]
                .split(":");
              const bTimeParts = b.time_from
                .split("T")[1]
                .split("Z")[0]
                .split(":");
              return (
                parseInt(aTimeParts[0]) * 60 +
                parseInt(aTimeParts[1]) -
                (parseInt(bTimeParts[0]) * 60 + parseInt(bTimeParts[1]))
              );
            });
          if (!!timeslots?.length) {
            deliverySchedule = {
              date: currentSchedule.date,
              day: currentSchedule.day,
              timeslot: timeslots[0],
            };
          } else {
            checkDate.setDate(checkDate.getDate() + 1);
          }
          count++;
        } while (!deliverySchedule?.timeslot && count < 180);
        this.currentDate = new Date();
        if (returntHtml) {
          const deliveryDate = new Date(deliverySchedule.date);
          const inDateMonth = deliveryDate.toLocaleDateString("en-SG", {
            day: "numeric",
            month: "short",
          });
          const customDateFormat = `${inDateMonth} ${deliverySchedule.timeslot?.timeslot_label?.replace(
            " - ",
            "-"
          )}`;
          earliestDeliveryData.push({ customDateFormat });
        } else {
          earliestDeliveryData.push({ deliverySchedule });
        }
      });
    return earliestDeliveryData;
  }
}

customElements.define("delivery-schedules", deliverySchedules);
